<template>
  <div class="m-container">
    <m_header></m_header>
    <div style="height: 550px;width: 100%;">
      <img src="../assets/img/banner.jpg" style="width: 100%; height: 100%;" alt="">
    </div>
    <div class="m-content">
      <div style="text-align: center;font-weight: bold;margin: 10px 0 0 0;font-size: 18px;">
        商家入驻平台指南
      </div>
      <div style="text-align: center;margin: 30px 0 0 0;">
        <img @click="openBuy()" src="../assets/img/ruzhu.png" width="500" alt="" class="zoom-image2"/>
      </div>
      <div style="display: flex;align-items: center;justify-content: center;">
        <div style="width: 680px;padding: 10px 0 0 0;">
          <div class="m-ruzhu-tit">一、入驻条件</div>
          <div class="m-ruzhu-tit-sm">1、企业资质</div>
          <div class="m-ruzhu-cont">合法注册：商家必须是合法登记的企业用户，具备独立的法人资格，不接受个体工商户或非中国大陆企业入驻。</div>
          <div class="m-ruzhu-cont">证件齐全：需提供有效的营业执照、税务登记证等证件。部分类目可能还要求提供组织机构代码证、一般纳税人资格证等。企业注册信息需真实有效，且企业经营无异常。</div>
          <div class="m-ruzhu-tit-sm">2、商品与品牌</div>
          <div class="m-ruzhu-cont">品牌要求：商家需拥有自主品牌或获得品牌授权，品牌需具备一定的市场影响力和竞争力。商标状态应为R标（已注册商标）或TM标（正在注册中的商标，但入驻难度相对较大）。部分类目可能还有特定的品牌要求，如品牌评估报告等。
            商品质量：商品需符合国家标准和行业规范，不能存在质量问题。商家需提供商品的质量检测报告、产品认证证书等相关材料，以确保商品的质量和安全性。</div>
          <div class="m-ruzhu-tit-sm">3、经营实力与信誉</div>
          <div class="m-ruzhu-cont">经营实力：企业需具备一定的规模和实力，包括注册资本、固定资产、员工人数等，以证明其具备一定的资金实力和经营能力。信誉评级：商家需诚信经营，维护良好的商家信誉和口碑，无严重违规行为记录。我们将评估企业的品牌经营实力，包括品牌成立时间、线下经营情况、淘宝或其他平台经营情况等。</div>
          <div class="m-ruzhu-tit-sm">4、服务能力</div>
          <div class="m-ruzhu-cont">售后服务：商家需提供完善的售后服务体系，包括退换货政策、客户投诉处理机制等，确保消费者在购买过程中得到良好的体验。</div>
          <div class="m-ruzhu-cont">物流配送：商家需具备稳定的物流配送能力，确保商品能够及时、准确地送达消费者手中。</div>
          <div class="m-ruzhu-tit-sm">5、其他要求</div>
          <div class="m-ruzhu-cont">遵守规则：商家需遵守平台的各项规则和政策。</div>
          <div class="m-ruzhu-cont">特定类目要求：部分特定类目可能有额外的资质要求和审批流程，商家需提前了解并准备相关材料。</div>
          <!--         费用详解 -->
          <div class="m-ruzhu-tit">二、费用详解</div>
          <div class="m-ruzhu-tit-sm">1、保证金</div>
          <div class="m-ruzhu-cont">保证金是商家入驻平台时需要缴纳的一笔费用，用于保证商家按照平台规则经营并履行相关义务。保证金金额根据店铺类型和经营类目的不同而有所差异，一般在5千元至2万元。具体金额需以官方公布的信息为准。</div>
          <div class="m-ruzhu-tit-sm">2、软件服务费（佣金）</div>
          <div class="m-ruzhu-cont">软件服务费是商家在平台上销售商品时需要支付的费用，根据销售额的一定比例（费率）计算。费率因类目和销售额的不同而有所差异，一般在0.5%至5%之间。该费用是实时划扣的，即每当成交一笔订单时，平台会按照约定的费率从订单金额中划扣相应的服务费。</div>
          <!--         入驻流程 -->
          <div class="m-ruzhu-tit">三、入驻流程</div>
          <div class="m-ruzhu-cont">1、访问官网并提交申请：商家需访问官网，点击“立即入驻”按钮，填写并提交入驻申请。申请内容包括企业信息、品牌信息、商品信息等。</div>
          <div class="m-ruzhu-cont">2、平台审核：平台将对商家提交的资质进行审核，包括品牌评估、资质初审和复审等环节。商家需积极配合审核工作，提供相关证明文件。</div>
          <div class="m-ruzhu-cont">3、完善店铺信息并缴费：审核通过后，商家需按照要求完善店铺信息，并缴纳保证金和（如适用）软件服务费。商家还需与平台签订入驻合同，明确双方的权利和义务。</div>
          <div class="m-ruzhu-cont">4、店铺上线：完成上述步骤后，商家即可在平台上开设店铺并上架商品。商家需确保所售商品的描述、图片、价格等信息真实准确、合法。</div>
        </div>
      </div>
    </div>
    <m_bottom></m_bottom>
    <el-dialog title="请输入入驻信息" :visible.sync="openState" @close='closeDialog' width="650px" center>
      <div class="m-open-container">
        <div class="zs-open-body-ov" style="margin-right: 40px;">
          <el-form :model="form" :rules="rules" ref="form" label-width="110px">
            <el-form-item label="姓名: " prop="name">
              <el-input v-model="form.name" placeholder="输入您的姓名"></el-input>
            </el-form-item>
            <el-form-item label="联系方式: " prop="phone">
              <el-input v-model="form.phone" placeholder="输入您的电话"></el-input>
            </el-form-item>
            <el-form-item label="所在地区: " prop="selectedOptions">
              <div>
                <el-cascader
                  size="large"
                  :options="options"
                  v-model="selectedOptions"
                  @change="handleChange"
                >
                </el-cascader>
              </div>
            </el-form-item>
            <el-form-item label="详细地址: " prop="address">
              <el-input v-model="form.address" placeholder="输入您的详细地址"></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div slot="footer" class="dialog-foote" style="text-align: center;">
          <el-button @click="openState = false">取 消</el-button>
          <el-button type="primary" @click="submit()">确 定</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {CodeToText, regionData} from 'element-china-area-data'

export default {
  name: 'ruZhu',
  data () {
    return {
      options: regionData,
      selectedOptions: [],
      listIndex: 0,
      buyType: 0,
      openState: false,
      openBuyState: false,
      buyLoading: false,
      form: {
        name: '',
        city: '',
        address: '',
        phone: ''
      },
      optionIndex: 'operate',
      homeOptions: [
        {type: 'operate', title: '商城首页'},
        {type: 'zixun', title: '电商快讯'},
        {type: 'ruzhu', title: '商家入驻'}
      ],
      checkList: [],
      rules: {
        name: [
          { required: true, message: '请输入姓名', trigger: 'blur' }
        ],
        city: [
          { required: true, message: '请选择所属地区', trigger: 'blur' }
        ],
        address: [
          { required: true, message: '请输入详细地址', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '请输入联系电话', trigger: 'blur' }
        ]
      }
    }
  },
  created () {
    let id = this.$route.params.id
    for (let i = 0; i < this.dataList.length; i++) {
      if (this.dataList[i].id === id) {
        this.listIndex = i
      }
    }
  },
  methods: {
    toInfoBack () {
      this.$router.back()
    },
    selectBuyType (type) {
      this.buyLoading = true
      this.buyType = type
      setTimeout(() => {
        this.buyLoading = false
      }, 1000)
    },
    handleChange () {
      let loc = ''
      for (let i = 0; i < this.selectedOptions.length; i++) {
        loc += CodeToText[this.selectedOptions[i]]
      }
      this.city = loc
    },
    closeDialog () {
    },
    submit () {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.openState = false
          this.openBuyState = true
          this.buyLoading = true
          setTimeout(() => {
            this.buyLoading = false
          }, 1000)
        } else {
          return false
        }
      })
    },
    openBuy () {
      this.openState = true
    }
  },
  mounted () {
  }
}
</script>

<style>
.zoom-image2 {
  width: 500px;
  transition: transform 0.3s ease; /* Adds smooth transition effect */
  cursor:pointer;
  border-radius: 10px;
}

.zoom-image2:hover {
  transform: scale(1.03); /* Scales the image to 110% */
}
</style>



// WEBPACK FOOTER //
// src/components/RuZhu.vue